import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rem } from '@mantine/core';

export const Wrapper = styled.div<{
  img?: 'cover' | 'contain';
  imgSize?: number;
  isBlogDetail?: boolean;
}>`
  position: relative;
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  div.overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), 0%, rgba(0, 0, 0, 0.5), 100%);
  }

  img {
    object-fit: ${({ img = 'cover' }) => img};
    z-index: 0;
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 25px;
    align-items: center;
    justify-content: center;
    color: white;
    padding: 10px;

    h1 {
      font-size: ${rem(38)};
      font-weight: 700;
      max-width: 780px;
      z-index: 1;
      line-height: 1.2;
    }

    & > ul {
      z-index: 1;
      display: flex;
      column-gap: 40px;
      row-gap: 10px;
      list-style: none;
      font-weight: 600;
      font-size: ${rem(18)};
      flex-wrap: wrap;

      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        position: relative;

        svg {
          flex-shrink: 0;
        }

        &::after {
          position: absolute;
          z-index: 99;
          top: 0;
          right: 0;
          width: 10px;
          height: 220px;
          background-color: #7e7e7e;
        }
      }
    }
  }

  ${({ img, theme, imgSize }) =>
    img === 'contain' &&
    imgSize &&
    css`
      & > div {
        max-width: 1300px;
        height: 100%;
        width: 100%;
        align-items: start;
        justify-content: flex-end;
        padding: 20px;

        .mantine-Text-root {
          z-index: 2;
          max-width: 780px;
        }
      }

      &::before,
      &::after {
        content: '';
        display: block;
        width: 50vw;
        position: absolute;
        top: 0;
        bottom: 0;
        z-index: 1;
      }

      &::before {
        background: ${theme.colors.redGradientOpacityRight};
        left: ${`calc((100vw - ${imgSize}px) / 2 - 50vw + 10%)`};
      }

      &::after {
        background: ${theme.colors.redGradientOpacityLeft};
        right: ${`calc((100vw - ${imgSize}px) / 2 - 50vw + 10%)`};
      }

      @media (max-width: 900px) {
        img {
          object-position: top;
        }

        & > div {
          align-items: center;
          text-align: center;
        }

        &::after {
          width: 100%;
          height: 500px;
          left: 0;
          right: 0;
          top: unset;
        }

        &::before {
          display: none;
        }

        &::after {
          background: ${theme.colors.redGradientOpacityTop};
          bottom: calc((900px - 100vw) / 2 - 500px + 25%);
        }
      }
    `}
  ${({ img, isBlogDetail }) =>
    img === 'cover' &&
    isBlogDetail &&
    css`
      div.overlay {
        width: 100%;
        z-index: 1;
        background: rgba(0, 0, 0, 0.5);
      }
      & > div {
        height: 100%;
        width: 100%;
        align-items: center;
        justify-content: center;
        padding: 10px;
      }

      @media (max-width: 900px) {
        img {
          object-position: top;
        }

        & > div {
          align-items: center;
          text-align: center;
        }
      }
    `}
`;
